module.exports = __webpack_public_path__ + "static/media/warning.02087b3c.svg";